<header *ngIf="pageTitle !== 'email-confirmation'">
  <div class="container">
    <div class="header-container">
      <div class="small-menu">
        <a [routerLink]="['/', translate.currentLang, 'home']" class="logo">
          <img loading="lazy" src="assets/images/madfu-logo.svg" alt="Madfu" />
        </a>

        <button class="menu-toggle" id="menu-toggle" (click)="toggleMenu()">
          <img loading="lazy" src="/assets/images/menu.svg" alt="burger menu" />
        </button>
      </div>

      <ul class="nav-menu" [ngClass]="{ active: menuOpen }">
        <li>
          <a
            [routerLink]="['/', translate.currentLang, 'home']"
            routerLinkActive="active"
          >
            {{ "home" | translate }}
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/', translate.currentLang, 'about-us']"
            routerLinkActive="active"
          >
            {{ "about-us" | translate }}
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/', translate.currentLang, 'blogs']"
            routerLinkActive="active"
          >
            {{ "blogs-and-news" | translate }}
          </a>
        </li>

        <li class="small-screen-item">
          <button class="join-as-partner-button" (click)="openBePartnerPage()">
            {{ "join-as-partner" | translate }}
          </button>
        </li>

        <li class="small-screen-item">
          <button class="language-change" (click)="switchLang()">
            <img loading="lazy" src="assets/images/lang.svg" alt="world" />
            {{ "currentLanguage" | translate }}
          </button>
        </li>
      </ul>

      <ul class="nav-menu">
        <li>
          <button class="language-change" (click)="switchLang()">
            <img loading="lazy" src="assets/images/lang.svg" alt="world" />
            {{ "currentLanguage" | translate }}
          </button>
        </li>

        <li>
          <button class="join-as-partner-button" (click)="openBePartnerPage()">
            {{ "join-as-partner" | translate }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</header>
